import { useEffect, useState } from 'react';
import { fetchSsoStatus, SsoStatus } from 'src/app/services/sso';

/** SSO availability from the API; off until known and on any failure. */
export const useSsoStatus = (): SsoStatus => {
  const [status, setStatus] = useState<SsoStatus>({
    enabled: false,
    microsoft: false,
  });
  useEffect(() => {
    let active = true;
    fetchSsoStatus().then((value) => {
      if (active) setStatus(value);
    });
    return () => {
      active = false;
    };
  }, []);
  return status;
};
